module.exports = "/_next/static/images/JumpstartLite-9999491e9266f3abc20821e4dae7a688.png";